import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * The encryption feature is enabled when
 * 1. You're a premium consumer user with the cmp-encryption feature flag enabled (get the ProtectMessage version)
 * 2. You're an enterprise user with the cmp-manageIRM feature flag enabled and SegmentationSettings has Irm = true
 */
export default function isEncryptionEnabled() {
    return isConsumer()
        ? isFeatureEnabled('cmp-encryption') &&
              getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox
        : isFeatureEnabled('cmp-manageIRM') && getUserConfiguration().SegmentationSettings.Irm;
}
